import {
    apiRequest,
    riwayatangkakreditDetail
} from "../../../../../services/adapters/kepegawaian/riwayatangkakreditService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatangkakreditDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository